import { all, AllEffect } from 'redux-saga/effects';
import { GeneratedModule } from './module';

export interface InitConfig {
  activeSaga?: boolean;
}

export interface InitializedModules {
  actions: Record<string, Record<string, Function>>;
  types: Record<string, Record<string, string>>;
  reducers: Record<string, Function>;
  effects: Record<string, Record<string, Function>>; // 👈 Declarado como obligatorio
  rootSagas: () => Generator<AllEffect<any>, void, unknown>;
  sagas: any[];
}

/**
 * Module initializer
 * @param {Array} models of Models
 * @param {Object} config extra configs
 * @return {Object} actions/reducers/sagas generators
 */
export default (models: GeneratedModule<any>[], config: InitConfig = { activeSaga: true }): InitializedModules => {
  const actions: Record<string, Record<string, Function>> = {};
  const types: Record<string, Record<string, string>> = {};
  const reducers: Record<string, Function> = {};
  const effects: Record<string, Record<string, Function>> = {};
  let sagas: any[] = [];

  models.map(model => {
    let key = model.name;
    actions[key] = model.actionCreators;
    reducers[key] = model.reducer;
    types[key] = model.actionsTypes;
    effects[key] = model.effects;
    sagas = sagas.concat(model.sagas);
  });

  // Run all the watchers
  let rootSagas = function* root() {
    yield all(sagas);
  };

  return {
    actions,
    types,
    reducers,
    effects, // ✨ ¡Listo! Agregado aquí para cumplir con la interfaz
    rootSagas,
    sagas,
  };
};